import React from "react";
import IndexNav from "../../IndexNav";
import {
  Bullet,
  BulletList,
  Container,
  Intro,
  Page,
  Section,
  SectionTitle,
  Text,
  Title,
  UpdatedText,
} from "./Styled";

const Terms = () => {
  return (
    <>
      <IndexNav />
      <Page>
        <Container>
          <Title>PepHub Boards Terms and Conditions</Title>
          <UpdatedText>Last updated: April 11, 2026</UpdatedText>

          <Intro>
            These Terms and Conditions govern your access to and use of PepHub Boards. By creating an
            account or using the service, you agree to these terms.
          </Intro>

          <Section>
            <SectionTitle>1. Service Use</SectionTitle>
            <Text>
              PepHub Boards is a task and board management application. You may use the service only
              for lawful purposes and in accordance with these Terms.
            </Text>
          </Section>

          <Section>
            <SectionTitle>2. Accounts</SectionTitle>
            <Text>
              You are responsible for maintaining the confidentiality of your account credentials and
              for all actions under your account.
            </Text>
            <BulletList>
              <Bullet>Provide accurate and current registration information.</Bullet>
              <Bullet>Do not share credentials with unauthorized users.</Bullet>
              <Bullet>Notify us promptly if you suspect account misuse.</Bullet>
            </BulletList>
          </Section>

          <Section>
            <SectionTitle>3. User Content</SectionTitle>
            <Text>
              You retain ownership of board data and content you submit. You grant us permission to
              host, process, and display that content only to operate the service.
            </Text>
          </Section>

          <Section>
            <SectionTitle>4. Acceptable Use</SectionTitle>
            <Text>You agree not to misuse the platform, including by:</Text>
            <BulletList>
              <Bullet>Uploading malicious code or attempting unauthorized access.</Bullet>
              <Bullet>Using the service to violate applicable laws or regulations.</Bullet>
              <Bullet>Interfering with service security, stability, or availability.</Bullet>
            </BulletList>
          </Section>

          <Section>
            <SectionTitle>5. Availability and Changes</SectionTitle>
            <Text>
              We may improve, modify, suspend, or discontinue features at any time. We aim for high
              uptime but do not guarantee uninterrupted service.
            </Text>
          </Section>

          <Section>
            <SectionTitle>6. Termination</SectionTitle>
            <Text>
              We may suspend or terminate access for violations of these Terms or activity that risks
              users, systems, or legal compliance.
            </Text>
          </Section>

          <Section>
            <SectionTitle>7. Disclaimer and Liability</SectionTitle>
            <Text>
              PepHub Boards is provided on an "as is" and "as available" basis. To the maximum extent
              allowed by law, we disclaim implied warranties and limit liability for indirect or
              consequential damages.
            </Text>
          </Section>

          <Section>
            <SectionTitle>8. Contact</SectionTitle>
            <Text>
              For legal or terms-related questions, contact the PepHub Boards support team through the
              in-app feedback page.
            </Text>
          </Section>
        </Container>
      </Page>
    </>
  );
};

export default Terms;
